"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogoutPage = exports.LogoutPageConfig = void 0;
const mithril_1 = require("../mithril");
const services_1 = require("../services");
const page_1 = require("./page");
exports.LogoutPageConfig = {
    type: 'internal',
    name: page_1.IkePageName.logout,
    path: '/logout',
    auth: { required: false },
    layout: { nav: false, banner: false }
};
class LogoutPage extends page_1.IkePage {
    constructor() {
        super(exports.LogoutPageConfig);
    }
    get nodes() {
        return (0, mithril_1.m)('div', { onupdate: () => services_1.Services.User.logout(), oncreate: () => services_1.Services.User.logout() });
    }
}
exports.LogoutPage = LogoutPage;
//# sourceMappingURL=logout.page.js.map